import { addToGlobalThisRet } from "@plugins";

function initWorkStatusSwitcher() {
    const inputs = document.querySelector(".js-work-status-inputs");
    const labels = document.querySelector(".js-work-status-labels");

    if (labels) {
        labels.addEventListener("click", (e) => {
            if (e.target !== labels && !e.target.classList.contains("active")) {
                for (let i = 0; i < labels.children.length; i++) {
                    labels.children[i].classList.remove("active");
                }
                e.target.classList.add("active");
            }
        });
    }

    if (inputs && labels) {
        inputs.addEventListener("click", ({ target }) => {
            const currentInputIndex = [...inputs.children].findIndex((e) => e === target);

            if (currentInputIndex >= 0) {
                for (let i = 0; i < labels.children.length; i++) {
                    labels.children[i].classList.remove("active");
                }
                labels.children[currentInputIndex].classList.add("active");
            }
        });
    }
}

window.addEventListener("load", () => {
    initWorkStatusSwitcher();
});

addToGlobalThisRet(initWorkStatusSwitcher, "initWorkStatusSwitcher");
